export default __webpack_public_path__ + "static/media/proposalManager.9b2cb6b2.svg";